import { Component, effect, HostBinding, inject, input, Input, output, signal } from '@angular/core';
import { SliderComponent } from 'app/shared/slider/slider.component';
import { FacetFilterService } from '../facet-filter.service';

@Component({
  selector: 'app-facet-date-filter',
  standalone: true,
  imports: [SliderComponent],
  templateUrl: './facet-date-filter.component.html',
  styleUrl: './facet-date-filter.component.scss',
})
export class FacetDateFilterComponent {
  @Input() hideLine: boolean = false;
  showAdditionalTooltips = input(true);

  @HostBinding('class')
  get hostClasses(): string {
    return [
      'block',
      'w-[400px]',
      'pr-7',
      'mb-4',
      !this.hideLine ? 'mr-7' : 'mr-0',
      !this.hideLine ? 'border-r border-gray-300' : '',
    ].join(' ');
  }

  valueChange = output();
  private facetFilter = inject(FacetFilterService);
  currentSliderStartValue = signal<number | undefined>(undefined);
  currentSliderEndValue = signal<number | undefined>(undefined);

  startValue = this.facetFilter.start;
  endValue = this.facetFilter.end;
  minStart = this.facetFilter.minStart;
  maxEnd = this.facetFilter.maxEnd;

  constructor() {
    effect(() => {
      this.currentSliderStartValue.set(this.facetFilter.start())
      this.currentSliderEndValue.set(this.facetFilter.end())
    });
  }

  onValueChange() {
    this.facetFilter.isFilteredByDates.set(true);
    this.valueChange.emit();
  }
}
